import { useContext } from 'react';
import ToastContext from '../ToastContext';

function useToast() {
    const {
        toastList, setToastList, addToast, removeToast,
    } = useContext(ToastContext);

    return {
        toastList, setToastList, addToast, removeToast,
    };
}

export default useToast;
